export const NAME = 'cp:open'

export default function createEvent() {
    return new CustomEvent(NAME, {
        bubbles: true,
        composed: true,
    })
}
